import classNames from "classnames";
import { FormEvent } from "react";

const FooterSubscribe = ({ className }: { className?: string }) => {
  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    try {
      e?.preventDefault();
    } catch (error) {
      console.error();
    }
  };
  return (
    <div
      className={classNames(
        "flex flex-col items-center sm:items-start gap-2 [&>*]:w-full text-center sm:text-start",
        className
      )}
    >
      <h3 className="text-sm font-semibold ">Stay Updated</h3>
      <p className="text-xs sm:text-sm font-semibold text-stone-400 sm:text-slate-200">
        Get the latest deals, trends, and business tips in your inbox.
      </p>

      <form
        onSubmit={handleSubmit}
        className="w-full flex items-center gap-1 border border-slate-400 rounded-full overflow-hidden p-1 mt-3"
      >
        <input
          id="email"
          type="email"
          name="email"
          className="flex-1 px-3 py-4 h-9 rounded-tl-full rounded-bl-full bg-transparent text-white outline-0 border-none text-sm flex items-center justify-center "
          placeholder="Enter your email address"
        />
        <button
          type="submit"
          className="bg-main text-white flex items-center justify-center h-9 px-3 py-4 rounded-full outline-0 border-none"
        >
          subscribe
        </button>
      </form>
    </div>
  );
};

export default FooterSubscribe;
